import './mainheader.css'
import Card from '../../components/Card'

export const MainHeader = () => {
  return (
    <header className='main__header'>
        <div className="container main__header-container">
            <div className="main__header-left">
               <Card>
               <h1>AKME-K MEDICAL DIAGNOSTICS</h1>
                <p>...because we truly care</p>
                <p>Leading diagnostic center with top-notch equipment and professionals that offer great medical investigations. We provide 24-hours access to a medical laboratory, radiology (X-Ray and Ultrasound scan) and a dental clinic.</p>
                <div className="main__header-cta">
                  <div className="first__cta">
                    <a href="/Contact" className='btn primary'>Contact Us</a>
                 </div>
                </div>
               </Card>
            </div>
        </div>
    </header>
  )
}

export default MainHeader